<template>
  <div>
    <div v-if="loading.manager" class="h-100 d-flex justify-center align-center">
      <v-progress-circular :size="50" color="primary" indeterminate/>
    </div>

    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <ProfileTopPanel v-if="manager"
      userTypeName="Менеджер"
      :name="manager.last_name + ' ' + manager.first_name"
      :city="manager.city"
      :phone="manager.phone"
      :email="manager.email"
      :company="manager.company"
      permssionEdit="edit_manager"
      permssionDelete="пока уберем кнопку delete_manager"
      whoDelete="менеджера"
      @delete="onDelete()" @edit="onEdit()"
    >
      <div class="profile-header-item" style="margin-top:0">
        <v-switch v-if="!isProfile && $store.getters['auth/isAllowed']('edit_manager')"
          :input-value="manager.send_mail" @change="changeSendMail" :loading="loading.editMail"
          class="v-input--reverse profile-switch ml-4" hide-details :color="manager.send_mail ? 'success' : 'error'"
        >
          <div slot="label" :class="manager.send_mail ? 'success--text' : 'error--text'">Почта</div>
        </v-switch>
      </div>
    </ProfileTopPanel>

    <div class="row">
      <div class="col-12 col-md-6">
        <ManagerBalances
          v-if="manager"
          ref="balances"
          :user-id="manager.id"
          :enable-add="canAddStock"
          @add="onAddBalance"
        />
<!--        <ClientProfileCardCounters-->
<!--          testType="MMPI"-->
<!--          v-if="manager && ( $store.getters['auth/isAllowed']('view_stockamount_manager') || $store.getters['auth/isAllowed']('view_stockamount') )"-->
<!--          :user="manager"-->
<!--          @add="dialogAddLicencesShow=true"-->
<!--          :enableAdd="$store.getters['users/counters/getEndpoint']('manager') &&-->
<!--                    ( $store.getters['auth/isAllowed']('add_stockamount_manager') || $store.getters['auth/isAllowed']('add_stockamount') )"-->
<!--        />-->
<!--        <ClientProfileCardCounters-->
<!--          testType="MINIMULT"-->
<!--          v-if="manager && ( $store.getters['auth/isAllowed']('view_stockamount_manager') || $store.getters['auth/isAllowed']('view_stockamount') )"-->
<!--          :user="manager"-->
<!--          @add="dialogAddLicencesShow=true"-->
<!--          :enableAdd="$store.getters['users/counters/getEndpoint']('manager') &&-->
<!--                    ( $store.getters['auth/isAllowed']('add_stockamount_manager') || $store.getters['auth/isAllowed']('add_stockamount') )"-->
<!--        />-->
      </div>
<!--      <div class="col-12 col-md-6">-->
<!--        <ClientProfileCardCounters-->
<!--          testType="CONSTRUCTOR"-->
<!--          v-if="manager && ( $store.getters['auth/isAllowed']('view_stockamount_manager') || $store.getters['auth/isAllowed']('view_stockamount') )"-->
<!--          :user="manager"-->
<!--          @add="dialogAddLicencesShow=true"-->
<!--          :enableAdd="$store.getters['users/counters/getEndpoint']('manager') &&-->
<!--                    ( $store.getters['auth/isAllowed']('add_stockamount_manager') || $store.getters['auth/isAllowed']('add_stockamount') )"-->
<!--        />-->
<!--      </div>-->
    </div>
    <AddLicensesDialog v-model="dialogAddLicencesShow" :toId="+userId" toType='manager' @success="reload()" :testType="currentChangeTestType" />
    <ManagerEditDialog />

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ProfileTopPanel from '@/components/common/ProfileTopPanel';
import ManagerEditDialog from '@/components/managers/ManagerEditDialog';
import AddLicensesDialog from '@/components/admins/AddLicensesDialog.vue';
import ManagerBalances from '@/components/managers/profile/ManagerBalances.vue';
import { resolveOwner } from '@/common/models/walletStatistics';
import { ADMIN } from '@/common/constants/userTypes';

export default {
  name: 'ProfileManager',
  components: {
    ManagerBalances,
    ManagerEditDialog,
    AddLicensesDialog,
    ProfileTopPanel,
    // ClientProfileCardCounters
  },
  props: ['userId'],
  provide() {
    return {
      userType: 'Manager',
      userId: this.userId,
    };
  },
  data() {
    return {
      dialogAddLicencesShow: false,
      currentChangeTestType: '',
    };
  },
  inject: {
    isProfile: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      manager: 'users/managers/manager',
      loading: 'users/managers/loading'
    }),
    // Начисление менеджеру со счёта пользователя (у админа), как в прежнем блоке «Счетчики»
    canAddStock() {
      const allowed = this.$store.getters['auth/isAllowed'];
      return !!this.$store.getters['users/counters/getEndpoint']('manager')
        && (allowed('add_stockamount_manager') || allowed('add_stockamount'));
    },
    isAdminUser() {
      const user = this.$store.getters['auth/user'];
      return !!user && user.user_type === ADMIN;
    },
    breadcrumbs() {
      if (!this.manager) return [];
      return this.isProfile ? [
        { title: 'Личный кабинет', url: '/' },
      ] : [
        // Менеджер корпа открывается из карточки корпа — крошки ведут обратно в неё.
        ...(this.manager.customer && this.manager.customer.id && this.$store.getters['auth/isAllowed']('view_corpclient') ? [
          ...(this.$store.getters['auth/isAllowed']('bookmark_corporate_clients') ? [{ title: 'Клиенты', url: '/clients/' }] : []),
          { title: this.manager.customer.company || 'Корп. клиент', url: `/clients/${this.manager.customer.id}` },
        ] : [
          // Список менеджеров открыт только админу: остальным крошка вела бы на «нет доступа»
          ...(this.isAdminUser ? [{ title: 'Менеджеры', url: '/managers/' }] : []),
        ]),
        { title: `${this.manager.last_name} ${this.manager.first_name}`, url: `/managers/${this.manager.id}` },
      ];
    },
  },
  methods: {
    ...mapActions({
      loadManager: 'users/managers/loadManager',
      setDialogEditShow: 'users/managers/setDialogEditShow',
      setManagerSendMail: 'users/managers/setManagerSendMail',
    }),
    ...mapMutations({
      setEditedManager: 'users/managers/setEditedManager'
    }),
    onEdit() {
      this.setEditedManager({ ...this.manager });
      this.setDialogEditShow(true);
    },
    onDelete() {
    },
    reload() {
      this.loadManager(this.userId);
      if (this.$refs.balances) this.$refs.balances.load();
    },
    onAddBalance(item) {
      this.currentChangeTestType = item.code;
      this.dialogAddLicencesShow = true;
    },
    changeSendMail(value) {
      this.setManagerSendMail({ send_mail: !!value, id: this.manager.id });
    },
    changeCounterLicenses(counter) {
      this.currentChangeTestType = counter.data.code;
      this.dialogAddLicencesShow = true;
    },

  },
  async created() {
    try {
      await this.loadManager(this.userId);
    } catch (e) {
      return;
    }
    // Ушли со страницы или в сторе другой менеджер — не перенаправляем.
    if (this.$route.name !== 'managers-id' || !this.manager || String(this.manager.id) !== String(this.userId)) return;
    // Технический менеджер корпа отдельной карточки не имеет — показываем карточку самого корпа.
    const owner = !this.isProfile && resolveOwner(this.manager);
    if (owner && owner.type === 'corpclient' && this.$store.getters['auth/isAllowed']('view_corpclient')) {
      this.$router.replace({ name: 'clients-id', params: { id: owner.id } });
    }
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/styles/variables";
</style>
